import styled from 'styled-components';
import InputBase from '@material-ui/core/InputBase';

const AppBarSearch = styled(InputBase)`
  && {
    flex: 1;
    padding: 0;
    margin-right: ${props => props.theme.spacing()}px;
    margin-left: ${props => props.theme.spacing()}px;

    input {
      padding-top: 3px;
      padding-bottom: 2px;
    }
  }
`;

AppBarSearch.propTypes = { ...InputBase.propTypes };

export default AppBarSearch;
